module.exports = __webpack_public_path__ + "img/jiqi.f0c3da45.jpg";